import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from 'antd';
export const StandardSkeleton = ({ loading = true, rows = 4, children }) => {
    if (!loading)
        return _jsx(_Fragment, { children: children });
    return _jsx(Skeleton, { active: true, paragraph: { rows } });
};
export default StandardSkeleton;
//# sourceMappingURL=StandardSkeleton.js.map